module.exports = __webpack_public_path__ + "static/media/all_feature.65966ef1.webp";